module.exports = __webpack_public_path__ + "static/media/reports.0b1ca8e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/reports.svg
// module id = 183
// module chunks = 1